import React from 'react';
import moment from 'moment';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
import { View } from '../View';
import { User } from '../User';
import { Text } from '../Text';
import { TextBlock, AppointmentBlock, FileBlock } from './components';
import { Block } from './components/Block';
export const Message = ({ data, author, time, onAppointmentPreview, onFilePreview, onFileDownload, customMessageRenderers }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container }, data
        .filter((item) => item.type === 'sketch' ? (customMessageRenderers === null || customMessageRenderers === void 0 ? void 0 : customMessageRenderers.sketch) != null : true)
        .map((item, index) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
        const SketchBlock = customMessageRenderers === null || customMessageRenderers === void 0 ? void 0 : customMessageRenderers.sketch;
        return (React.createElement(Block, { key: item.id, style: styles.wrapper }, ({ hovered }) => {
            var _a, _b;
            return (React.createElement(React.Fragment, null,
                index === 0 ? (React.createElement(User, { size: 'md', name: (_a = author.name) !== null && _a !== void 0 ? _a : 'GoPeer GoPeer', image: author.image, type: author.type, style: styles.user, online: author.online, lastSeen: author.lastActiveAt })) : (React.createElement(View, { style: styles.subtime }, hovered ? (React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: styles.time }, moment(item.createdAt).format('h:mm'))) : null)),
                React.createElement(View, { style: styles.main },
                    index === 0 ? (React.createElement(View, { style: styles.header },
                        React.createElement(Text, { type: 'headline', size: 'lg', style: styles.name }, (_b = author.name) !== null && _b !== void 0 ? _b : 'GoPeer'),
                        React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: [styles.time, styles.time__withMargin] }, moment(time).format('h:mm A')))) : null,
                    item.type === 'appointment' ? (React.createElement(AppointmentBlock, { data: item.data, isLoading: item.isLoading, onPress: onAppointmentPreview })) : item.type === 'sketch' ? (React.createElement(SketchBlock, { id: item.data.id })) : item.type === 'file' ? (React.createElement(FileBlock, { data: item.data, onPress: onFilePreview, onDownload: onFileDownload, author: author })) : (React.createElement(TextBlock, { data: item.data })))));
        }));
    })));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        marginBottom: size.C
    },
    wrapper: {
        flexDirection: 'row',
        paddingLeft: size.E
    },
    main: {
        marginLeft: size.C,
        paddingRight: size.C + 40,
        flex: 1
    },
    header: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        paddingTop: size.C
    },
    user: {
        marginTop: size.C,
        alignSelf: 'flex-start'
    },
    name: {
        color: color.invert2.p100
    },
    time: {
        color: color.invert2.p56
    },
    time__withMargin: {
        marginLeft: size.C
    },
    subtime: {
        width: size.M,
        alignItems: 'flex-end',
        justifyContent: 'center'
    }
}));
export { TextBlock };
export * from './types';
//# sourceMappingURL=index.js.map